import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { extractKeys } from '../../common/helpers';
import { muiGridSizes } from '../../common/constants';
import { TableHolderPaper, WidgetHeadingContainer } from './StyledContainers';

export default function TitledWidgetItem({
  title = null,
  children,
  rightTopComp = null,
  showTitle = true,
  size,
  ...otherProps
}) {

  const [sizeProps] = extractKeys(otherProps, muiGridSizes);
  const TitleComp = title && (typeof title !== 'string') && title;

  return (
    <Grid size={size || sizeProps}>
      <TableHolderPaper>
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', right: '0px' }}>
            { rightTopComp }
          </div>
        </div>

        <WidgetHeadingContainer>
          {showTitle && (typeof title === 'string') && (
            <Typography
              component="h6"
              variant="subtitle2"
              gutterBottom
            >
              {title}
            </Typography>
          )}

          {TitleComp && <TitleComp />}
          {children}
        </WidgetHeadingContainer>
      </TableHolderPaper>
    </Grid>
  );
}

TitledWidgetItem.propTypes = {
  title: PropTypes.string,
  rightTopComp: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  showTitle: PropTypes.bool,
};
